"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var base_1 = __importDefault(require("../base"));
var AdminReturnReasonsResource = /** @class */function (_super) {
  __extends(AdminReturnReasonsResource, _super);
  function AdminReturnReasonsResource() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @description Creates a return reason.
   * @param payload
   * @param customHeaders
   * @returns Created return reason.
   */
  AdminReturnReasonsResource.prototype.create = function (payload, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }
    var path = "/admin/return-reasons";
    return this.client.request("POST", path, payload, {}, customHeaders);
  };
  /**
   * @description Updates a return reason
   * @param id id of the return reason to update.
   * @param payload update to apply to return reason.
   * @param customHeaders
   * @returns the updated return reason.
   */
  AdminReturnReasonsResource.prototype.update = function (id, payload, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }
    var path = "/admin/return-reasons/".concat(id);
    return this.client.request("POST", path, payload, {}, customHeaders);
  };
  /**
   * @description deletes a return reason
   * @param id id of return reason to delete.
   * @param customHeaders
   * @returns Deleted response
   */
  AdminReturnReasonsResource.prototype.delete = function (id, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }
    var path = "/admin/return-reasons/".concat(id);
    return this.client.request("DELETE", path, undefined, {}, customHeaders);
  };
  /**
   * @description retrieves a return reason
   * @param id id of the return reason to retrieve.
   * @param customHeaders
   * @returns the return reason with the given id
   */
  AdminReturnReasonsResource.prototype.retrieve = function (id, customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }
    var path = "/admin/return-reasons/".concat(id);
    return this.client.request("GET", path, undefined, {}, customHeaders);
  };
  /**
   * @description Lists return reasons matching a query
   * @returns a list of return reasons matching the query.
   * @param customHeaders
   */
  AdminReturnReasonsResource.prototype.list = function (customHeaders) {
    if (customHeaders === void 0) {
      customHeaders = {};
    }
    var path = "/admin/return-reasons";
    return this.client.request("GET", path, undefined, {}, customHeaders);
  };
  return AdminReturnReasonsResource;
}(base_1.default);
exports.default = AdminReturnReasonsResource;